// components/CountdownBanner/index.jsx
import React, { useEffect, useState } from 'react';
import { Background, Title, Text, TimeSegment, Link } from './style';

const CountdownBanner = () => {
  const targetDate = new Date('2025-06-25T09:00:00');

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = new Date();
    const diff = targetDate - now;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Background>
      <Title>Future of Tax</Title>
      <Text>Faltam</Text>
      <TimeSegment>{timeLeft.days} <span>DIAS</span></TimeSegment>
      <TimeSegment>{timeLeft.hours} <span>HORAS</span></TimeSegment>
      <TimeSegment>{timeLeft.minutes} <span>MINUTO</span></TimeSegment>
      <TimeSegment>{timeLeft.seconds} <span>SEGUNDOS</span></TimeSegment>
      <Link href="https://lp.taxcel.com.br/future-of-tax-summit-by-taxcel">Garanta sua vaga<span>aqui</span></Link>
    </Background>
  );
};

export default CountdownBanner;
